import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var SvgMembership = function SvgMembership(_a) {
  var title = _a.title,
    desc = _a.desc,
    titleId = _a.titleId,
    descId = _a.descId,
    props = __rest(_a, ["title", "desc", "titleId", "descId"]);
  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  props['aria-labelledby'] = ariaLabelledBy;
  return jsxs("svg", __assign({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !!ariaLabelledBy
  }, props, {
    children: [!!title && jsx("title", __assign({
      id: titleId
    }, {
      children: title
    }), void 0), !!desc && jsx("desc", __assign({
      id: descId
    }, {
      children: desc
    }), void 0), jsx("path", {
      d: "M10 16L10 12",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M13 16L13 12",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M16 16L16 12",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M19 16L19 12",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M8 10.5V7H11.5",
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M8 17V20.5H11.5",
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M21 10.5V7H17.5",
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeLinejoin: "round"
    }, void 0), jsx("path", {
      d: "M21 17V20.5H17.5",
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
};

export { SvgMembership as default };
